import { Socket } from "socket.io-client";

export const isSocket = (socket: any): socket is Socket => {
  return socket instanceof Socket;
};